import { call, put, takeLatest } from 'redux-saga/effects';
import approvalAccountService from '../../../services/approvalAccountService';
import {
  fetchInit,
  fetchInitSuccess,
  fetchInitFailure,
  fetchApprovalAccounts,
  fetchApprovalAccountsSuccess,
  fetchApprovalAccountsFailure,
  deleteApprovalAccount,
  deleteApprovalAccountSuccess,
  deleteApprovalAccountFailure,
  bulkDeleteApprovalAccounts,
  bulkDeleteApprovalAccountsSuccess,
  bulkDeleteApprovalAccountsFailure,
  fetchUnassignedUsers,
  fetchUnassignedUsersSuccess,
  fetchUnassignedUsersFailure,
  assignUsers,
  assignUsersSuccess,
  assignUsersFailure,
} from './slice';

function* handleFetchInit() {
  try {
    const response = yield call(approvalAccountService.getInit);
    yield put(fetchInitSuccess(response));
  } catch (error) {
    const errorMessage = error.message;
    yield put(fetchInitFailure(errorMessage));
  }
}

function* handleFetchUnassignedUsers(action) {
  try {
    const { type, page, pageSize } = action.payload || {};
    const response = yield call(approvalAccountService.getUnassignedUsers, type, page, pageSize);
    yield put(fetchUnassignedUsersSuccess(response));
  } catch (error) {
    const errorMessage = error.message;
    yield put(fetchUnassignedUsersFailure(errorMessage));
  }
}

function* handleAssignUsers(action) {
  try {
    const { type, userIds } = action.payload || {};
    const response = yield call(approvalAccountService.assignUsers, type, userIds);
    yield put(assignUsersSuccess(response));
  } catch (error) {
    const errorMessage = error.message;
    yield put(assignUsersFailure(errorMessage));
  }
}

function* handleFetchApprovalAccounts(action) {
  try {
    const { type, page, pageSize } = action.payload || {};
    const response = yield call(approvalAccountService.getApprovalAccounts, type, page, pageSize);
    yield put(fetchApprovalAccountsSuccess(response));
  } catch (error) {
    const errorMessage = error.message;
    yield put(fetchApprovalAccountsFailure(errorMessage));
  }
}

function* handleDeleteApprovalAccount(action) {
  try {
    const response = yield call(approvalAccountService.deleteApprovalAccount, action.payload);
    yield put(deleteApprovalAccountSuccess(response));
  } catch (error) {
    const errorMessage = error.message;
    yield put(deleteApprovalAccountFailure(errorMessage));
  }
}

function* handleBulkDeleteApprovalAccounts(action) {
  try {
    const response = yield call(approvalAccountService.bulkDeleteApprovalAccounts, action.payload);
    yield put(bulkDeleteApprovalAccountsSuccess(response));
  } catch (error) {
    const errorMessage = error.message;
    yield put(bulkDeleteApprovalAccountsFailure(errorMessage));
  }
}

export function* watchApprovalAccountsActions() {
  yield takeLatest(fetchInit.type, handleFetchInit);
  yield takeLatest(fetchApprovalAccounts.type, handleFetchApprovalAccounts);
  yield takeLatest(deleteApprovalAccount.type, handleDeleteApprovalAccount);
  yield takeLatest(bulkDeleteApprovalAccounts.type, handleBulkDeleteApprovalAccounts);
  yield takeLatest(fetchUnassignedUsers.type, handleFetchUnassignedUsers);
  yield takeLatest(assignUsers.type, handleAssignUsers);
}
